import { ExtraPackagePayment } from './extraPackagePayment';
import {
  ExtraPackageDoveIt, ExtraPackagePriceType, ExtraPackageProvider, ExtraPackageSPF, ExtraPackageType,
} from './extraPackageType';

export interface ExtraPackage {
  id: number | null,
  name: ExtraPackageType,
  price?: number,
  priceType: ExtraPackagePriceType,
  providedBy: ExtraPackageProvider,
  legacy: boolean,
  payment?: ExtraPackagePayment,
}

export const DOVEIT_EXTRA_PACKAGES_DEFAULT_VALUES: Record<ExtraPackageDoveIt, number | undefined> = {
  EXTRA_VISIBILITY: undefined,
  PREMIUM_VISIBILITY: undefined,
  INTERIOR_RESTYLING: undefined,
  PRESTIGE: undefined,
  PHOTO_PLUS: undefined,
  DRONE: undefined,
  PERSONALIZED_MARKETING: undefined,
  PHOTO_PRO: undefined,
  INTERIOR_DESIGN: undefined,
  DRONE_VIDEO: undefined,
  REFURBISHMENT: undefined,
  ENGLISH_VIDEO: undefined,
  URBAN_PLANNING: undefined,
  BUILDING_REGULARITY: undefined,
  ENERGY_PERFORMANCE_CERTIFICATE: undefined,
  APE: undefined,
  CASA_OK: undefined,
  ALL_IN_ONE: undefined,
};

export const DOVEIT_EXTRA_PACKAGES_DEFAULT = [
  {
    name: ExtraPackageDoveIt.EXTRA_VISIBILITY,
    supportedPayments: [
      ExtraPackagePayment.AT_OFFER_ACCEPTANCE,
    ],
  }, {
    name: ExtraPackageDoveIt.INTERIOR_RESTYLING,
    supportedPayments: [
      ExtraPackagePayment.AT_OFFER_ACCEPTANCE,
    ],
  }, {
    name: ExtraPackageDoveIt.DRONE,
    supportedPayments: [
      ExtraPackagePayment.AT_ASSIGNMENT_SIGNATURE,
    ],
  }];

export const SPF_EXTRA_PACKAGES_DEFAULT_VALUES: Record<ExtraPackageSPF, number | undefined> = {
  SPF_APE: 200,
  DOCUMENTS_ACCESS: 100,
  VERIFICATION_SERVICE: 299,
};
